export default {

  init: function() {
    const fields = document.querySelectorAll('.field')
    fields.forEach((field) => {

      const formInput = field.querySelector('input,textarea,select')

      if (!formInput) {
        return;
      }

      if (formInput.value) {
        field.classList.add('focus')
      }

      formInput.addEventListener('focus', (event) => {
        const field = event.target.closest('.field')
        field.classList.add('focus')
      })

      formInput.addEventListener('blur', (event) => {
        const field = event.target.closest('.field')

        if (!event.target.value) {
          field.classList.remove('focus')
        }
      })
    })


    const singleForms = document.querySelectorAll('.form-single')
    singleForms.forEach((singleForm) => {

      const formInput = singleForm.querySelector('input')

      formInput.addEventListener('focus', () => {
        singleForm.classList.add('focus')
      })

      formInput.addEventListener('blur', (event) => {
        const singleForm = event.target.closest('.form-single')
        const input = event.target

        if (!input.value) {
          singleForm.classList.remove('focus')
        }
      })
    })

    document.addEventListener( 'wpcf7invalid', function( event ) {

      const formContainer = event.target

      const apiResponse = event.detail.apiResponse
      apiResponse.invalid_fields.forEach((field) => {
        formContainer.querySelector(field.into).classList.add('invalid')
      })

      console.log('API Response', event.detail.apiResponse)
    });

    document.querySelectorAll('form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.target.querySelectorAll('invalid').forEach((element) => {
          element.classList.remove('invalid')
        })
      })
    })
  }
}
